import { Component, h, Prop } from '@stencil/core';
import { 
  manageTooltipWithStorage, 
  isTooltipLocallyStored, 
  removeTootipFromDOM, 
  appendTooltip
} from './tooltip.js'

const arrowOrientation = {
  topLeft: 'hd-tooltip-top-left',
  topMiddle: 'hd-tooltip-top-middle',
  topRight: 'hd-tooltip-top-right',
  bottomLeft: 'hd-tooltip-bottom-left',
  bottomMiddle: 'hd-tooltip-bottom-middle',
  bottomRight: 'hd-tooltip-top-right',
  leftTop: 'hd-tooltip-left-top'
}
@Component({
  tag: 'hd-tooltip',
  styleUrl: './hd-tooltip.pcss',
  shadow: false
})

export class HdTooltip {

  @Prop() targetId!: string; // 'elementID'
  @Prop() orientation!: string; // 'topLeft'
  @Prop() position!: string; // 'top'
  @Prop() coord!: string; // '{ "desktop": { "top": "-10px"; "left: 20px" }, "mobile": { "top": "10px"; "right": "20px" }, "tablet": { "top": "5px" } }'

  selectorParentElement: HTMLElement 
  selectorElement: HTMLElement
  positionY: number
  positionX: number
  toolTipKey: string
  wasTooltipClosed: boolean
  shouldRender: boolean = true

  componentWillLoad() {
    const element = document.getElementById(this.targetId);
    if (!element) {
      return this.shouldRender = false
    }

    this.selectorElement = element
    this.selectorParentElement = element.parentElement
    this.toolTipKey = `hd-tooltip-${this.targetId}`
    this.wasTooltipClosed = isTooltipLocallyStored(this.toolTipKey)
  }

  componentDidLoad() {
    appendTooltip(this.selectorElement, this.selectorParentElement, this.toolTipKey, this.position, this.coord, this.orientation)
    if (this.wasTooltipClosed || !this.shouldRender) {
      removeTootipFromDOM(this.toolTipKey)
    } else {
      manageTooltipWithStorage(this.toolTipKey)
    }
  }

  render () {
    if (!this.shouldRender) return null

   return ( 
      <div id={`js-${this.toolTipKey}`} class={`hd-tooltip ${arrowOrientation[this.orientation] || arrowOrientation['topLeft']}`} >
        <button class="icon-block hd-tooltip__close js-hd-tooltip-close"><hd-icon svg='cancel' width="10" height="10"></hd-icon></button>
        <slot></slot>
      </div>
    )
  }
}